import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeAddOtherGql } from '../bimWorkOrderChangeUploadOtherQueries';

import type { convertCheckedHelperArgsType } from './convertCheckedHelper';
import { convertCheckedHelper } from './convertCheckedHelper';

type TAddToBimWorkOrderChange = {
    workOrderChangeId: number;
    constructionTypeId: number | undefined;
    checkedIds: convertCheckedHelperArgsType['checkedIds'];
    handlerSuccess: () => void;
};

const requestId = 'addOtherToBimWorkOrderChange';

export const useAddToBimWorkOrderChange = (props: TAddToBimWorkOrderChange) => {
    const dispatch = useDispatch();

    const { workOrderChangeId, handlerSuccess, checkedIds, constructionTypeId } = props;

    const addVariables = useMemo(() => {
        if (workOrderChangeId && checkedIds && constructionTypeId) {
            return {
                constructionTypeId,
                workOrderChangeId,
                otherPrices: convertCheckedHelper({
                    checkedIds,
                }),
            };
        }

        return null;
    }, [checkedIds, constructionTypeId, workOrderChangeId]);

    const [, status, , request] = useRequest({
        requestId,
        query: bimWorkOrderChangeAddOtherGql,
        withEffect: false,
        dependenciesUpdater: handlerSuccess,
    });

    const [resetData] = useResetStoreData({
        requestId,
    });

    useEffect(
        () => () => {
            resetData(undefined);
        },
        [resetData],
    );

    const addToWorkOrderChangeHandler = useCallback(() => {
        if (addVariables) {
            dispatch(request({ input: addVariables }));
        }
    }, [dispatch, request, addVariables]);

    const isAddInProgress = status === RequestStatus.FETCHING;

    return {
        isAddInProgress,
        addToWorkOrderChangeHandler,
    };
};
